import type { PromoterIntegrationTaskApi } from '../../../api/promoter-integration-task'
import type { PromoterIntegrationTask } from '../../../api/promoter-integration-task/types'

const fastInterval = 3_000
const slowInterval = 10_000

export default abstract class PromoterTaskFetcher {
  api: PromoterIntegrationTaskApi

  protected constructor(api: PromoterIntegrationTaskApi) {
    this.api = api
  }

  abstract getAuthPromoterOid(): number | null | undefined

  abstract get isFetching(): boolean

  abstract set isFetching(value: boolean)

  abstract get interval(): number | null

  abstract set interval(value: number | null)

  abstract setPending(tasks: PromoterIntegrationTask[]): void

  abstract setCompleted(tasks: PromoterIntegrationTask[]): void

  async start() {
    const promoterOid = this.getAuthPromoterOid()
    if (!promoterOid) {
      return
    }
    if (this.isFetching) {
      return
    }
    this.stop()
    try {
      this.isFetching = true
      const [pendingTasks, completedTasks] = await Promise.all([
        this.api.fetchPending(promoterOid),
        this.api.fetchCompleted(promoterOid),
      ])
      this.setPending(pendingTasks)
      this.setCompleted(completedTasks)
      // refresh more frequently when there are pending tasks
      const intervalTime = pendingTasks.length ? fastInterval : slowInterval
      this.interval = window.setInterval(() => this.start(), intervalTime)
    }
    catch (e) {
      if (!this.interval) {
        this.interval = window.setInterval(() => this.start(), slowInterval)
      }
      throw e
    }
    finally {
      this.isFetching = false
    }
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
}
